import type { IconProps } from './types';

export const TrashIcon: React.FC<IconProps> = (props) => {
    return (
        <svg {...props} id="icoTrash" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="Group_14473" data-name="Group 14473">
                <path
                    id="Path_6532"
                    data-name="Path 6532"
                    d="M18.17,8.92v9.25a3.081,3.081,0,0,1-3.08,3.08H8.92a3.081,3.081,0,0,1-3.08-3.08V8.92"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_6533"
                    data-name="Path 6533"
                    d="M3.78,5.83H20.22"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_6534"
                    data-name="Path 6534"
                    d="M8.92,5.83a3.08,3.08,0,1,1,6.16,0"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_6535"
                    data-name="Path 6535"
                    d="M9.94,12l4.12,4.11"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_6536"
                    data-name="Path 6536"
                    d="M14.06,12,9.94,16.11"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
            <rect id="Rectangle_6649" data-name="Rectangle 6649" width="24" height="24" fill="none" />
        </svg>
    );
};
